<template>
  <div
    class="flex flex-col justify-center items-center before:absolute before:inset-x-0 before:top-0 before:h-64 before:bg-stone-50"
  >
    <div class="mt-7 mb-9 z-10 flex flex-col items-center space-y-4">
      <img src="/img/polri-logo.png" alt="" class="h-24" />
      <p class="font-bold text-xl text-zinc-700 capitalize">
        {{ appName }}
      </p>
    </div>
    <section
      class="bg-stone-800 shadow-lg z-10 p-6 mx-4 sm:w-96 sm:mx-0 rounded-xl border border-zinc-300 text-white"
    >
      <div class="my-4 space-y-4">
        <h1 class="text-2xl text-center text-slate-200">{{ title }}</h1>
        <p v-if="description" class="text-center text-sm text-slate-200">
          {{ description }}
        </p>
      </div>

      <slot></slot>

      <p
        class="text-center mt-16 mb-0.5 text-xs text-neutral-400 leading-relaxed"
      >
        Copyright © {{ new Date().getFullYear() }} Rotekinfo Div TIK Polri.
        <span class="block"> All Rights Reserved. {{ version }} </span>
      </p>
    </section>
    <div class="my-12 space-y-2">
      <p class="text-center text-sm text-gray-600">Didukung oleh:</p>
      <img src="/img/logo-bsre.png" alt="" class="h-12" />
    </div>
  </div>
</template>

<script>
import { version } from "/package.json";
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      appName: import.meta.env.VITE_APP_NAME,
      version: version,
    };
  },
};
</script>

<style></style>
